import { render, staticRenderFns } from "./bankid-modal.vue?vue&type=template&id=4411b044&"
import script from "./bankid-modal.vue?vue&type=script&lang=js&"
export * from "./bankid-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports